import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { dataCalcoloPenalitaHelper, getContribBiennaleControl } from './helpers/contrib-biennale-form.helpers';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';
import { toNum } from '@shared/helpers/math.helper';

export const contribBiennaleContributoRules: FormGroupRules = {
    my_MotivoModificaContrib: (form: FormGroup) => {
        const my_MotivoModificaContribControl = getContribBiennaleControl(form, 'my_MotivoModificaContrib');
        const my_ContributoDovutoModif: string = getContribBiennaleControl(form, 'my_ContributoDovutoModif')?.value;
        const my_ContribDovuto: string = getContribBiennaleControl(form, 'my_ContribDovuto')?.value;
        const showError = isNilOrEmpty(my_MotivoModificaContribControl?.value) && my_ContributoDovutoModif !== my_ContribDovuto;
        const errors = my_MotivoModificaContribControl.errors ? my_MotivoModificaContribControl.errors : {};

        addRemoveError(showError, errors, 'my_MotivoModificaContrib', {
            status: REQUIRED_STATUS,
        });

        my_MotivoModificaContribControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ContribVersato: (form: FormGroup) => {
        const my_ContribVersatoControl = getContribBiennaleControl(form, 'my_ContribVersato');
        const errors = my_ContribVersatoControl.errors ? my_ContribVersatoControl.errors : {};

        addRemoveError(isNilOrEmpty(my_ContribVersatoControl?.value), errors, 'my_ContribVersato', {
            status: REQUIRED_STATUS,
        });

        my_ContribVersatoControl.setErrors(isEqual(errors, {}) ? null : errors);
        dataCalcoloPenalitaHelper(form, `${formPaths.contributoBiennale}.my_ContribVersato`);
    },

    my_MaggEntiEdilVersata: (form: FormGroup) => {
        const my_MaggEntiEdilVersataControl = getContribBiennaleControl(form, 'my_MaggEntiEdilVersata');
        const my_MaggEntiEdilDovuta = toNum(getContribBiennaleControl(form, 'my_MaggEntiEdilDovuta')?.value);
        const my_ScEdilObbl: string = getControl(form, `${formPaths.schedaCoopEdil}.my_ScEdilObbl`)?.value;
        const showError = isNilOrEmpty(my_MaggEntiEdilVersataControl?.value) && my_MaggEntiEdilDovuta > 0 && my_ScEdilObbl === '1';
        const errors = my_MaggEntiEdilVersataControl.errors ? my_MaggEntiEdilVersataControl.errors : {};

        addRemoveError(showError, errors, 'my_MaggEntiEdilVersata', {
            status: 'Se la cooperativa edilizia non ha versato la maggiorazione inserire il valore 0.',
        });

        my_MaggEntiEdilVersataControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
